import React from "react";
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import ClaytonCredentialsForm from "./ClaytonCredentialsForm";
import ClaytonConfigListing from "./ClaytonConfigListing"

export default function ClaytonPullAndPushView(props){
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={ClaytonCredentialsForm}
            PullConfigListingView={ClaytonConfigListing}
        />
    )
}